<template>
  <section class="pay vh100">
    <div class="pay-scroller">
      <pay-ticket
        v-if="isWpsIos"
        :course-data="courseResourceData.iosPayCourseInfo" />
      <pay-money
        v-else
        :course-data="courseData"
        :coupon-list="couponList"
        :discount-price="discountPrice"
        :is-loan-app="isLoanApp"
        :can-loan="canLoan"
        :bonus="bonus"
        :discount-bonus="discountBonus"
        @selectBonus="handleSelectBonus"
        @selectCoupon="handleSelectCoupon"
        @selectPayWay="handleSelectPayWay" />
    </div>
    <div class="pay-bar">
      <div>
        实付款：
        <span v-if="!isWpsIos">￥{{ finalPayPrice | fixedNumber(2)}}</span>
        <span v-else>{{ finalPayPrice | fixedNumber(2)}}券</span>
      </div>
      <div v-if="isLoanApp && canLoan"
           class="pay-bar-tip">
        <!-- 分期月供<i>{{ monthSupply }}</i>元起 -->
        <i>{{ monthSupply }}</i>
      </div>
      <div class="pay-bar-button"
           @click="handlePay">立即支付</div>
    </div>
    <RetainBubble
      ref="retain"
      :isRetain="isRetain"
      :price="finalPayPrice"/>
  </section>
</template>

<script>
  import os from '@edu-fe/os'
  import Pay from '@edu-fe/pay'
  import api from '@edu-fe/api'
  import module from '../modules/pay'
  import { mapState, mapActions } from 'vuex'
  import fixedNumber from '../filters/fixed-number.js'
  import PayMoney from '../components/PayMoney.vue'
  import PayTicket from '../components/PayTicket.vue'
  import RetainBubble from '../components/RetainBubble'

  import { isxxx } from '@mixins'
  import Cookie from 'js-cookie'

  export default {
    name: 'Pay',
    components: {
      PayMoney,
      PayTicket,
      RetainBubble
    },
    data () {
      return {
        monthSupply: 0, // 金山贷款最低分期月供
        selectedCoupon: {}, // 选择的优惠券
        payWay: '10', // 支付方式 9: 支付宝 10: 微信 11: 金山贷分期
        isLoanApp: os.name === 'loan', // 借款app环境
        // isLoanApp: true // 借款app环境
        paying: false,
        // discountBonus: 0,  // 奖励金减免价格
        selectedBonus: 0,  // 奖励金实际选中价格
        isBonusSelected: false, //奖励金是否被选中
      }
    },
    computed: {
      ...mapState(['launchOptions']),
      ...mapState(module.name, {
        courseData: state => state.courseData,
        couponList: state => state.couponList,
        courseResourceData: state => state.courseResourceData,
        bonus: state => state.bonus,
        isRetain: state => state.isRetain
      }),
      discountPrice () {
        let discount = this.selectedCoupon.value
        if (this.selectedCoupon.discountType === 2) { // 折扣券
          discount = this.courseData.price * (1 - discount)
        }
        return discount || 0
      },
      // 是否使用优惠券的价格
      payPrice () {
        if (!this.isWpsIos) {
          // let price = this.courseData.price
          // price -= this.discountPrice
          return 0.02
          // return price < 0 ? 0 : +fixedNumber(price, 2)
        } else {
          // return this.courseResourceData.iosPayCourseInfo.price
          return 0.01
        }
      },
      // 最后支付价格
      finalPayPrice () {
        return this.payPrice - this.selectedBonus < 0 ? 0 : fixedNumber(this.payPrice - this.selectedBonus, 2)
      },
      canLoan () { // 是否支持金山贷分期
        // const minLimit = window.jsBridge ? window.jsBridge.getPriceMiniLimit() : 10000
        // return minLimit <= this.courseData.price
        return false
      },
      discountBonus () {
        let val = this.payPrice
        if (!val) {
          return 0
        }

        if (this.bonus <= val) {
          return this.bonus
        } else {
          return val
          // this.discountBonus = this.bonus - val
        }
      },
      autoPay () {
        return this.$route.query['_edu_auto_pay']
      },
      isFromVip () {
        return this.$route.query.isVipPage
      }
    },
    /*
    * 监听payPrice确定discountBouns
    * 监听discountBonus 手动调用 点选奖励金
    * */
    watch: {
      discountBonus: {
        handler () {
          this.handleSelectBonus(this.isBonusSelected)
        },
        immediate: true
      },
      courseData: {
        handler (val) {
          if (val.id && this.autoPay) {
            setTimeout(() => {
              this.handlePay()
            }, 300)
          }
        },
        deep: true
      }
    },
    filters: {
      fixedNumber
    },
    mixins: [
      isxxx
    ],
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    async created () {
      const { courseId, type } = this.$route.query

      if (this.isWpsIos) { // ios客户端使用资源券支付，查询不同讯息
        this['pay/getResource']({ courseId })
      } else {
        await this['pay/getCourseData']({ courseId })
        await this['pay/getCouponList']({ courseId, type })
        await this['pay/getBonus']({ courseId })
        // this['pay/getRetain']({ courseId })

        Pay.enterPayment(orderId => this.gotoResult(orderId))
      }
    },
    mounted () {
      this.$nextTick(() => {
        const barDom = document.querySelector('.bar')
        const height = barDom ? barDom.offsetHeight : 0

        this.$el.style.height = `${window.innerHeight - height}px`
      })

      if (this.isLoanApp) {
        this.monthSupply = window.jsBridge.getMouthSupply()
      }

      // 解决iosWps height继承上个页面的问题
      if(os.type === 'app') {
        this.$el.height = `${ window.innerHeight }px`
      }
    },
    beforeDestroy () {
      this.$store.unregisterModule(module.name)
      if (!this.isWpsIos) {
        Pay.leavePayment()
      }
    },
    methods: {
      ...mapActions([
        'pay/getCourseData',
        'pay/getCouponList',
        'pay/getResource',
        'pay/payByResource',
        'pay/payByStage',
        'pay/getBonus',
        'pay/getRetain'
      ]),

      gotoResult (orderId) {
        // 以下 loan 皆为对 分期app 的处理
        const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + this.$route.query.courseId

        // 分期跳转
        if (os.name === 'loan' && window.jsBridge) {
          return jsBridge.goToEduSuccess(JSON.stringify({
            page: 'KSWPSPageController',
            animated: false,
            urlString: page
          }))
        }

        // 1元训练营跳转图片
        if (os.type === 'weixin' && (this.courseData.isPromote === 1 || this.courseData.campType > 0)) {
          // return window.location.assign(`/sign-up-result-for-promote?courseId=${this.$route.query.courseId}`)
          return this.$router.replace({
            name: 'sign-up-result-for-promote',
            query: {
              courseId: this.$route.query.courseId
            }
          })
        }

        window.location.href = page
      },
      handleSelectCoupon (coupon) {
        this.selectedCoupon = coupon
      },
      handleSelectPayWay (way) {
        this.payWay = way
      },
      handleSelectBonus (selectBonus) {
        this.isBonusSelected = selectBonus

        if (selectBonus) {
          this.selectedBonus = this.discountBonus
        } else {
          this.selectedBonus = 0
        }
      },
      handlePay () {
        console.log(this.isWpsIos)
        console.log(this.payWay)
        // if (this.paying) {
        //   return console.log('正在支付...')
        // }
        this.paying = true
        if (this.payWay === '11') { // 金山贷分期支付
          console.log('loan---')
        } else { // 普通支付
          
          if (!this.isWpsIos) {
            if (!this.payWay) return alert('选择支付方式')
            /* eslint-disable */
            new Pay({
              type: this.courseData.type || 1,
              courseId:  this.courseData.id,
              from: this.$route.query['order_from'] || this.launchOptions.from,
              payWay: +this.payWay,
              price: this.finalPayPrice,
              market:this.$route.query.market || '',
              couponId: this.selectedCoupon.id,
              isSend: this.$route.query.isSend || 0,
              token: this.$route.query.token,
              usedReward: this.isBonusSelected ? 1 : 0,
              payment: true,
              loginCallback: wpsSid => {
                this.paying = false
              },
              gotoResult: orderId => {
                this.paying = false
                this.gotoResult(orderId)
              },
              failCallback: () => {
                this.paying = false
              },
              cancelCallback: () => {
                this.$refs.retain.show()
                this.paying = false
              }
            })
            /* eslint-enable */
          } else {
            if (this.courseResourceData.userResourceNumber < this.courseResourceData.iosPayCourseInfo.price) {
              const dialog = this.$dialog({
                title: '请充值',
                text: `您的资源券数量为${this.courseResourceData.userResourceNumber}`,
                buttons: [
                  {
                    type: 1,
                    text: '取消',
                    handler: () => {
                      this.paying = false
                      dialog.close()
                    }
                  },
                  {
                    text: '确认',
                    handler: () => {
                      this.paying = false
                      window.webkit.messageHandlers.showBuyCoupons.postMessage(0)
                    }
                  }
                ]
              })
            } else {
              this['pay/payByResource']({
                courseId: this.courseResourceData.iosPayCourseInfo.id
              }).then(res => {
                this.paying = false
                if (res.msg === 'success') { // 支付成功
                  this.gotoResult(res.data)
                } else {
                  this.$toast.show({
                    message: '支付失败'
                  })
                }
              })
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  @mixin setBorderInRetina($pos) {
    @if $pos == 'top' {
      &::before {
        content: '';
        transform: scaleY(.5);
        transform-origin: 0 1px;
        position: absolute;
        top: 0;
        width: 100%;
        height: 1px;
        background-color: #ececec;
      }
    } @else {
      &::after {
        content: '';
        transform: scaleY(.5);
        transform-origin: 0 1px;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #ececec;
      }
    }
  }

  .pay {
    overflow: hidden;
    position: relative;
    // max-height: 100%;
    width: 100%;
    /*height: 100%;*/
    font-family: PingFangSC-Regular;
    -webkit-overflow-scrolling: auto;

    &-scroller {
      box-sizing: border-box;
      overflow-y: scroll;
      overflow-x: hidden;
      height: 100%;
      width: 100%;
      padding-bottom: rem(150);
      background-color: #ececec;
    }

    &-resource {
      margin-bottom: rem(20);
      padding: rem(38) rem(30) rem(20);
      background-color: #fff;
      font-size: rem(26);
      color: #666;

      &::before {
        content: '课程信息';
        display: block;
        font-weight: bold;
        color: #333;
      }

      &::after {
        content: '售价：'attr(data-price)'券';
        display: block;
        text-align: right;
      }
    }

    &-course {
      margin-bottom: rem(20);
      padding: rem(38) rem(30) rem(20);
      background-color: #fff;
      font-size: rem(26);
      color: #666;

      &::before {
        content: '课程信息';
        display: block;
        font-weight: bold;
        color: #333;
      }

      &::after {
        content: '售价：￥'attr(data-price);
        display: block;
        text-align: right;
      }

      &-info {
        @include setBorderInRetina('top');
        @include setBorderInRetina('bottom');
        display: flex;
        position: relative;
        margin: rem(25) 0 rem(20);
        padding: rem(20) 0;
        width: 100%;

        & > div {
          display: inline-block;

          &:first-child {
            margin-right: rem(30);
            width: rem(194);

            & > img {
              display: block;
              width: 100%;
            }
          }

          &:last-child {
            width: rem(466);
            line-height: 1.5;
            color: #333;
          }
        }
      }
    }

    /** course end **/

    &-bonus, &-coupon {
      position: relative;
      margin-bottom: rem(20);
      padding: 0 rem(30);
      background-color: #fff;

      $elementPadding: rem(25);

      &::before {
        content: '代金券';
        display: block;
        padding: $elementPadding 0;
        font-weight: bold;
        font-size: rem(26);
      }
      &-button {
        position: absolute;
        top: $elementPadding;
        right: rem(30);
        height: rem(26);
        line-height: rem(26);

        &.spread {
          &::after {
            transform: rotate(180deg);
          }
        }

        &.selected {
          &::before {
            content: '-￥'attr(data-coupon);
            margin-right: rem(20);
            font-size: rem(26);
            color: #f48f00;
          }
        }

        &::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          transition: transform .15s linear;
          width: rem(20);
          height: rem(10);
          background: {
            image: url('../assets/images/pay-icon-arrow.png');
            repeat: no-repeat;
            size: 100% 100%;
          }
        }
      }

      &-list {
        transition: all .15s linear;
        transform: scaleY(0);
        transform-origin: 0 0;
        height: 0;
        opacity: 0;

        &.spread {
          transform: scaleY(1);
          height: auto;
          opacity: 1;
        }

        & > li {
          @include setBorderInRetina('top');
          position: relative;
          padding: rem(35) 0;
          font-size: rem(28);
          color: #999;

          &::after {
            $size: rem(35);
            transform: translateY(-50%);
            position: absolute;
            top: 50%;
            right: 0;
            content: '';
            width: $size;
            height: $size;
            border: 1px solid #ececec;
            border-radius: 50%;
          }

          &.active {
            color: #666;

            &::after {
              border: none;
              background: {
                image: url('../assets/images/schedule-icon-s.png');
                repeat: no-repeat;
                size: contain;
              }
            }
          }
        }
      }
    }
    &-bonus {
      &::before {
        content: '奖励金';
      }
      &-button {
        &.selected {
          &::before {
            content: '-￥'attr(data-bonus);
          }
        }

      }
    }
    /** coupon end **/

    &-method {
      padding: 0 rem(30);
      background-color: #fff;

      $elementPadding: rem(25);

      &::before {
        content: '支付方式';
        display: block;
        padding: $elementPadding 0;
        font-weight: bold;
        font-size: rem(26);
      }

      &-button {
        position: absolute;
        top: $elementPadding;
        right: rem(30);
        height: rem(26);
        line-height: rem(26);

        &.spread {
          &::after {
            transform: rotate(180deg);
          }
        }

        &::before {
          content: '-￥'attr(data-coupon);
          margin-right: rem(20);
          font-size: rem(26);
          color: #f48f00;
        }

        &::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          transition: transform .15s linear;
          width: rem(20);
          height: rem(10);
          background: {
            image: url('../assets/images/pay-icon-arrow.png');
            repeat: no-repeat;
            size: 100% 100%;
          }
        }
      }

      &-list {
        & > li {
          @include setBorderInRetina('top');
          position: relative;
          padding: rem(35) 0;
          font-size: rem(28);
          color: #999;

          &::after {
            $size: rem(35);
            transform: translateY(-50%);
            position: absolute;
            top: 50%;
            right: 0;
            content: '';
            width: $size;
            height: $size;
            border: 1px solid #ececec;
            border-radius: 50%;
          }

          &.active {
            color: #666;

            &::after {
              border: none;
              background: {
                image: url('../assets/images/schedule-icon-s.png');
                repeat: no-repeat;
                size: contain;
              }
            }
          }
        }
      }
    }

    /** method end **/

    &-bar {
      box-sizing: border-box;
      // position: absolute;
      position: fixed;
      bottom: 0;
      left: 0;
      padding: rem(30);
      width: 100%;
      background-color: #fff;
      font-size: rem(32);
      color: #666;

      &::before {
        content: '';
        transform: scaleY(.5);
        transform-origin: 0 1px;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 1px;
        background-color: #ececec;
      }

      & span {
        color: #f48f00;
      }

      &-tip {
        margin-top: rem(10);
        font-size: rem(20);

        & > i {
          color: #ff6845;
        }
      }

      &-button {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: rem(240);
        height: 100%;
        background-color: #f48f00;
        font-size: rem(34);
        color: #fff;
        user-select: none;
      }
    }
  }

  $global-width: 720;
</style>
